module.exports = __webpack_public_path__ + "img/75b78fa.jpg";